/** @format */

import dayjs from 'dayjs'
import { _$ } from '@king-design/react'
import { hourMinute, monthDayHourMinute, hourMinuteSecond } from 'src/config'
import { ProductItem } from 'src/utils/interface'
// 监控视图组件props
export interface IMonitorViewProps {
  className?: string
  productList: ProductItem[]
  dashboardName: string
  graph: IMonitorGraphData
  index: number
  start: number
  end: number
  delay: number
  reload: () => void
}

// 监控视图table data
export interface IMonitorViewDataObject {
  instanceId: string
  name: string
  unit: string
  max: number
  min: number
  avg: number
}

// 监控视图data
export interface IMonitorGraphData {
  start?: number
  end?: number
  dashboardId?: number
  graphId?: number
  title: string
  graphType: 'line' | 'bar' | 'pie'
  metrics: IMonitorGraphLineData[]
  interval?: number
}

// 监控视图数据下监控项data
export interface IMonitorGraphLineData {
  graphMetricId?: number
  productType: number
  memberId?: number
  metricKey: string
  metricName: string
  units: string
  delay: number
  instances?: IMonitorGraphLineInstanceData[]
  metricTags?: string[]
  aggregator: 'max' | 'min' | 'average' | 'sum'
  resourceAggregator: 'max' | 'min' | 'average' | 'sum' | ''
  tagsAggregator: 'max' | 'min' | 'average' | 'sum' | ''
  isDimension?: 1 | 2
}

export const initMenberData: IMonitorGraphLineData = {
  graphMetricId: Math.round(-1000 * Math.random()),
  productType: undefined,
  metricKey: '',
  metricName: '',
  units: '',
  delay: 0,
  instances: [],
  metricTags: [],
  aggregator: 'max',
  resourceAggregator: '',
  tagsAggregator: ''
}

export const initEditGraphData: IMonitorGraphData = {
  title: '',
  graphType: 'line',
  metrics: [
    {
      ...initMenberData
    }
  ]
}

// 监控视图 - 监控项 - 实例信息
export interface IMonitorGraphLineInstanceData {
  instanceId: string
  instanceIP: string
  instanceName: string
  region?: string
}

// 计算图表layout
export const handleGridLayouts = data => {
  return {
    lg: data?.map((item, index) => ({
      i: item.graphId.toString(),
      x: (index % 2) * 6,
      y: Math.floor(index / 3) * 2,
      w: 6,
      minW: 6,
      h: 8,
      minH: 8,
      maxH: 20
    })),
    sm: data?.map((item, index) => ({
      i: item.graphId.toString(),
      x: 0,
      y: Math.floor(index / 2) * 2,
      w: 10,
      minW: 5,
      h: 8,
      minH: 8,
      maxH: 20
    })),
    xs: data?.map((item, index) => ({
      i: item.graphId.toString(),
      x: 0,
      y: Math.floor(index * 2),
      w: 6,
      minW: 6,
      h: 8,
      minH: 8,
      maxH: 20
    }))
  }
}
// lg=1269
export const gridBreakpoints = { lg: 1200, sm: 768, xs: 480 }
export const gridCols = { lg: 12, sm: 10, xs: 6 }

// 图表表头结构可选项
export const chartTableScheme = [
  {
    title: _$('图例名称'),
    key: 'name'
  },
  // {
  //   title: '实例名称',
  //   key: 'instaceName'
  // },
  // {
  //   title: '实例信息',
  //   key: 'IP'
  // },
  {
    title: _$('最大值'),
    key: 'max'
  },
  {
    title: _$('最小值'),
    key: 'min'
  },
  {
    title: _$('平均值'),
    key: 'avg'
  },
  {
    title: _$('求和值'),
    key: 'sum'
  }
]

// 计算粒度
export const calcInterval = (): number => {
  return 60
}

// 根据时间差设置日期转换格式
export const handleDateFormat = (date, delay) => {
  const [start, end] = date
  if (start && end) {
    const diff = dayjs(end).diff(dayjs(start), 's')
    const oneDay = 24 * 60 * 60
    if (diff < oneDay) {
      return delay < 60 ? hourMinuteSecond : hourMinute
    } else {
      return monthDayHourMinute
    }
  }
  return monthDayHourMinute
}

// 倒计时秒转字符串
export const secondsToText = (s: number) => {
  const seconds = Math.floor(s % 60)
    .toString()
    .padStart(2, '0')
  const minutes = Math.floor((s / 60) % 60)
    .toString()
    .padStart(2, '0')

  return `${minutes}:${seconds}`
}

// 图表类型
export const graphType = [
  {
    title: '折线图',
    value: 'line'
  }
  // {
  //   title: '柱状图',
  //   value: 'bar',
  // },
  // {
  //   title: '饼状图',
  //   value: 'pie',
  // }
]

// 计算delayOption
// 30分钟以内：默认周期, 1分钟
// 30分钟-1天(包含)：3分钟, 5分钟, 10分钟, 15分钟, 30分钟, 1小时
// 1天-3天(包含)：10分钟, 15分钟, 30分钟, 1小时, 2小时
// 3天-7天(包含)：30分钟, 1小时, 2小时
// 7天-14天(包含)：1小时, 2小时, 4小时
// 14天-31天(包含)：2小时, 4小时, 6小时, 1天
// 大于31天：6小时, 1天
export const calcSelectInterval = (start, end, graphs) => {
  const diff = dayjs(end).diff(dayjs(start), 's')
  // 默认周期
  let defaultDelay = 5
  // 单图最大总条数
  let lineCount = 0
  graphs.forEach(graph => {
    let graphCount = 0
    graph.metrics?.forEach(metric => {
      graphCount += metric?.instances?.length
      if (metric?.delay > defaultDelay) {
        defaultDelay = metric?.delay
      }
    })
    lineCount = graphCount > lineCount ? graphCount : lineCount
  })
  if (lineCount) {
    let delayOption = []
    const day = 24 * 60 * 60
    if (diff <= 1800) {
      delayOption = _derepeatedSort([defaultDelay, 60])
    } else if (diff <= day) {
      delayOption = [180, 300, 600, 900, 1800, 3600]
    } else if (diff <= day * 3) {
      delayOption = [600, 900, 1800, 3600, 7200]
    } else if (diff <= day * 7) {
      delayOption = [1800, 3600, 7200]
    } else if (diff <= day * 14) {
      delayOption = [3600, 7200, 14400]
    } else if (diff <= day * 31) {
      delayOption = [7200, 14400, 21600, 86400]
    } else {
      delayOption = [21600, 86400]
    }
    return delayOption
  } else {
    return [180, 300, 600, 900, 1800, 3600]
  }
}

// delay 秒->时
export const delayToHours = delay => {
  if (delay < 60) {
    return _$(`${delay}秒`)
  } else if (delay < 3600) {
    return _$(`${delay / 60}分钟`)
  } else if (delay < 86400) {
    return _$(`${delay / 60 / 60}小时`)
  } else {
    return _$(`${delay / 86400}天`)
  }
}

// 数组去重排序
export const _derepeatedSort = (arr: number[]): number[] => {
  return Array.from(new Set(arr)).sort((a, b) => a - b)
}
